import { render, staticRenderFns } from "./FarmUnitDisplay.vue?vue&type=template&id=08e35d61&scoped=true&"
import script from "./FarmUnitDisplay.vue?vue&type=script&lang=ts&"
export * from "./FarmUnitDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./FarmUnitDisplay.vue?vue&type=style&index=0&id=08e35d61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e35d61",
  null
  
)

export default component.exports